import useGlobalSettings from "@components/_hooks/useGlobalSettings";
import dynamic from "next/dynamic";

const GoogleWidget = dynamic(() => import('../HomeComponent/GoogleWidget'), { ssr: true })
const EssaWidget = dynamic(() => import('../HomeComponent/EssaWidget'), { ssr: true })

const FooterAccreditation = ({ type }) => {
    const {getSetting} = useGlobalSettings()
    const show_google_review = getSetting('footer_show_trustpilot', 'no') === 'yes';
    const google_status = getSetting('google_status', '0') === '1';
    const google_url = getSetting('google_url', null);

    return (
        <div className={`${type == 'mobile' ? 'd-flex' : ''}`}>
            {show_google_review  && 
             google_status &&
             google_url != null && <GoogleWidget google_url={google_url} />}
            <EssaWidget type='mobile' />
        </div>
    )
}

export default FooterAccreditation
